import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <p>&copy; 2026 Bob the Raspberry Pi. Powered by React & Google Cloud.</p>
        <p>Built with ❤️ for automation and monitoring</p>
      </div>
    </footer>
  );
};

export default Footer;